module.exports = require('./lib/axios');


//////////////////
// WEBPACK FOOTER
// ./node_modules/axios/index.js
// module id = ./node_modules/axios/index.js
// module chunks = 6 9 11